import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7630b64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "floating-input relative" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "flex flex-row items-center mt-2"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-error",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  })
], -1))
const _hoisted_5 = { class: "text-sm overflow-ellipsis text-error ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Field, {
      type: _ctx.typeInput,
      name: _ctx.name,
      id: _ctx.name,
      disabled: _ctx.disabled,
      value: _ctx.modelValue,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
      placeholder: _ctx.name,
      autocomplete: "off",
      class: _normalizeClass(["focus:outline-none focus:ring-2 focus:ring-black focus:bg-white rounded-xl w-full p-4 h-16 appearance-none bg-gray-100", {
        'ring-2 ring-error': _ctx.error || _ctx.isError,
      }])
    }, null, 8, ["type", "name", "id", "disabled", "value", "placeholder", "class"]),
    _createElementVNode("label", {
      for: _ctx.label,
      class: _normalizeClass(["absolute top-0 left-0 px-4 py-5 h-full pointer-events-none transform origin-left transition-all text-gray-400 duration-200 ease-in-out", {
        'text-error': _ctx.error || _ctx.isError,
      }])
    }, _toDisplayString(_ctx.label), 11, _hoisted_2),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.error), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}